/**
 * Single source of truth for visible-range list page size.
 * Legacy `useGetMeetingsQuery` and SuperGraph paths must use the same value.
 */
export const VISIBLE_RANGE_PAGE_SIZE = 100
